import React from "react";
import { CheckOutlined, ExclamationOutlined } from "@ant-design/icons";
import smartVitalGif from "../../Assets/Images/AiReport/smartVital.gif";

const reportContent = {
  smart_care: {
    title: "Uploading your facial scan video...",
    description: "Please wait here and do breathing Exercise with us while we are uploading your facial scan video. It will take a few seconds.",
    descriptionSuccess: "Your video has been uploaded and will now be analyzed by our AI to generate an accurate, easy-to-understand report tailored to your condition.",
    titleSuccess: "Your video is successfully uploaded",
    analyzingText: "Uploading your video…",
    imageSrc: smartVitalGif,
    analyzingTextSuccess: "Your video upload is complete - analysis will begin next",
  },
};

export default function SmartVitalUploadProgress({
  solutionType = "smart_care",
  progressLabel = "Your progress",
  visible = true,
  progress = 0,
  onView,
  errorText
}) {
  if (!visible) return null;

  const content = reportContent[solutionType] || reportContent.smart_care;
  
  // Allow props to override default content (like error messages)
  const isSuccess = progress === 100 && !errorText;
  const displayTitle = errorText ? "Upload failed" :  (isSuccess ? content.titleSuccess : content.title);
  const displayDescription = errorText ? errorText : (isSuccess ? content.descriptionSuccess : content.description);
  const displayAnalyzingText = errorText ? "Please close and retry" :  (isSuccess ? content.analyzingTextSuccess : content.analyzingText);

  return (
    <div className="flex flex-col items-center justify-center w-full h-full min-h-[500px]">
      <div 
        className="bg-white flex flex-col items-center text-center mx-auto w-full p-6 rounded-2xl" 
        style={{
          fontFamily: "Inter",
          background: "radial-gradient(400px 637px at center, #00BB965E 0%, #00BB9612 40%, #D9D9D900 70%)"
        }}
      >
        <h1
  className="font-bold text-lg md:text-[24px] w-full md:w-[476px] mt-4"
  style={
    errorText
      ? { color: "#ff4d4f" }
      : {
          background:
            "var(--primary-gradient)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }
  }
>
  {displayTitle}
</h1>
        <p className="font-medium text-sm md:text-base text-center w-11/12 md:w-4/5 mb-0" style={{ color: "#666666" }}>
          {displayDescription}
        </p>
        <img
          src={content.imageSrc}
          alt="Analysis"
          className="w-[280px] h-[210px] md:w-[416px] md:h-[312px] object-contain mx-auto mt-2"
        />
        <div className="px-4 md:px-6 w-11/12 md:w-9/12">
          <div 
            className="w-[30px] h-[30px] md:w-[35px] md:h-[35px] rounded-full mx-auto flex items-center justify-center mt-1 p-1" 
            style={{ backgroundColor: isSuccess ? "#198038" : (errorText ? "#ff4d4f" : "#FF8D28") }}
          >
            <div className="text-black bg-transparent text-[16px] md:text-[20px] font-bold">
              {isSuccess ? <CheckOutlined /> : <ExclamationOutlined />}
            </div>
          </div>
          <p
  className="font-inter font-bold text-sm md:text-[18px] my-1"
  style={
    isSuccess
      ? {
          background:
            "var(--primary-gradient)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }
      : errorText
      ? { color: "#ff4d4f" }
      : { color: "#FF8D28" }
  }
>
  {displayAnalyzingText}
</p>
          <p className="font-bold text-xs leading-4 mb-0 text-left" style={{ color: "#8D8D8D" }}>
            {progressLabel}
          </p>
          <div className="flex justify-between items-center w-full">
            <p className="font-lato font-bold text-base md:text-[18px] mb-0" style={{ color: isSuccess ? "#198038" : (errorText ? "#ff4d4f" : "#FF8D28") }}>
              {progress}% complete
            </p>
          </div>
          <div className="w-full h-[8px] md:h-[12px] bg-[#D2D2D2] rounded-full mt-4 overflow-hidden">
            <div
              className="h-full"
              style={{
                width: `${progress}%`,
                backgroundColor: isSuccess ? "#198038" : (errorText ? "#ff4d4f" : "#FF8D28"),
                transition: `${isSuccess ? "width 0.6s ease" : "background-color 0.3s ease"}`,
              }}
            ></div>
          </div>
        </div>
        <button
  className="w-11/12 md:w-[364px] h-[40px] md:h-[48px] rounded-[24px] font-inter font-semibold text-sm md:text-[16px] mt-4 md:mt-8 text-white hover:opacity-90 active:opacity-80 disabled:opacity-50"
  style={{ backgroundColor: "var(--color-brand-primary)" }}
  disabled={!isSuccess}
  onClick={() => {
    if (isSuccess) {
      onView && onView();
    }
  }}
>
  View Report
</button>
      </div>
    </div>
  );
}
